import * as React from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumb } from 'components';
import ManageUsersContext from './ManageUsersContext';

const ManageUsersBreadcrumbs: React.FC = () => {
  const { breadcrumbRoutes } = React.useContext(ManageUsersContext);
  return (
    <Breadcrumb>
      {breadcrumbRoutes.map(({ breadcrumbName, path }) => (
        <Breadcrumb.Item key={breadcrumbName}>
          <Link to={path}>{breadcrumbName}</Link>
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
};

export default ManageUsersBreadcrumbs;
